import {$, w} from './constants';


const singleGallery = () => {
    ScrollTrigger.matchMedia({

        //4k
        "(min-width: 1441px)": function() {
            let sections = gsap.utils.toArray(".project__slide"),
            getMaxWidth = () => sections.reduce((val, section) => val + section.offsetWidth, 300),
            maxWidth = getMaxWidth(),
            scrollSpeed = .8,
            tl = gsap.timeline();

            function init() {
                gsap.set(sections, {x: 0});
                maxWidth = getMaxWidth();
                let position = 0,
                    distance = maxWidth - window.innerWidth;
                sections.forEach((section) => {
                    position += section.offsetWidth / distance;
                });
            }
        
            tl.to(sections, {
                x: () => window.innerWidth - maxWidth,
                duration: 10,
                ease: "none"
            });
        
            ScrollTrigger.create({
                animation: tl,
                trigger: ".project__slider",
                pin: true,
                anticipatePin: 1,
                scrub: 1,
                //start : "-=100",
                end: () => "+=" + maxWidth / scrollSpeed,
                invalidateOnRefresh: true
            });
            init();
            ScrollTrigger.addEventListener("refreshInit", init);
        },
        // desktop
        "(min-width: 991px) and (max-width: 1440px)": function() {
            let sections = gsap.utils.toArray(".project__slide"),
            getMaxWidth = () => sections.reduce((val, section) => val + section.offsetWidth, 0),
            maxWidth = getMaxWidth(),
            scrollSpeed = .8,
            tl = gsap.timeline();

            function init() {
                gsap.set(sections, {x: 0});
                maxWidth = getMaxWidth();
                let position = 0,
                    distance = maxWidth - window.innerWidth;
                sections.forEach((section) => {
                    position += section.offsetWidth / distance;
                });
            }
        
            tl.to(sections, {
                x: () => window.innerWidth - maxWidth,
                duration: 10,
                ease: "none"
            });
        
            ScrollTrigger.create({
                animation: tl,
                trigger: ".project__slider",
                pin: true,
                anticipatePin: 1,
                scrub: 1.5,
                //start : "-=100",
                end: () => "+=" + maxWidth / scrollSpeed,
                invalidateOnRefresh: true
            });
            init();
            ScrollTrigger.addEventListener("refreshInit", init);
        },
      
        // Tablets
        "(min-width: 651px) and (max-width: 990px)": function() {
            let sections = gsap.utils.toArray(".project__slide"),
            getMaxWidth = () => sections.reduce((val, section) => val + $(section).width(), 200),
            maxWidth = getMaxWidth(),
            scrollSpeed = 1,
            tl = gsap.timeline();
        
            function init() {
                gsap.set(sections, {x: 0});
                maxWidth = getMaxWidth();
                let position = 0,
                    distance = maxWidth - window.innerWidth;
                sections.forEach((section) => {
                    position += section.offsetWidth / distance;
                });
            }
        
            tl.to(sections, {
                x: () => window.innerWidth - maxWidth,
                duration: 10,
                ease: "none"
            });
        
            ScrollTrigger.create({
                animation: tl,
                trigger: ".project__slider",
                pin: true,
                scrub: 1,
                anticipatePin: 1,
                //start : "-=100",
                end: () => "+=" + maxWidth / scrollSpeed,
                invalidateOnRefresh: true
            });
            init();
            ScrollTrigger.addEventListener("refreshInit", init);
        },
        //Móvil
        "(max-width: 650px)": function() {
        }
	});
}

w.load(() => {
    console.log('Hello world from El Cultivo! --Load');
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    
	let vhc = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vhc', `${vhc}px`);

    if($('#gallery-horizontal').length){
        singleGallery();
    }

    if($('.awards__images').length){
        if($(w).width() > 901){
            $('.awards__table-block').hover(function() {
                console.log('hover')
                let node = $(this).attr('data-index');
                let target = $('.awards__images').find(`.awards__images-container[data-index="${node}"]`);
                $('.awards__images').addClass('show-flex');
                $(target).addClass('show')
            },function(){
                let node = $(this).attr('data-index');
                let target = $('.awards__images').find(`.awards__images-container[data-index="${node}"]`);
                $('.awards__images').removeClass('show-flex');
                $(target).removeClass('show')
            });
        }
    }
    
});

$(document).ready(function() {
    console.log('Hello world from El Cultivo! --Ready');
    //Cookies
    if(localStorage.getItem('celeste_cookie')){
        $('#cookie-celeste').addClass('hide');
    }else{
        $('#cookie-celeste').delay(900).addClass('show');
        $('#ok-cookie').click(() => {
            localStorage.setItem('celeste_cookie', 'true');
            $('#cookie-celeste').toggleClass(' show hide');
            console.log('Acepto cookies')
        })
    }

    //Creamos el submit del form para agregar al carrito
    $("#contact").submit(function(event){
        //Detenemos el form
        event.preventDefault();
        let formData = new FormData( this );
        let portfolio = document.getElementById('portfolio').files[0];

        formData.append('action', 'contact');
        formData.append('portfolio', portfolio);

        if( $('#privacy').prop('checked')) {

            $.ajax({
                type: "POST",
                url: cltvo_js_vars.ajax_url,
                data: formData,
                cache: false,
                contentType: false,
                processData: false,
                success: function(data){
                    alert( data.message );
                    $('#job').val('');
                    $('#name').val('');
                    $('#email').val('');
                    $('#phone').val('');
                    $('#website').val('');
                    $('#experience').val('');
                    $('#software-skills').val('');
                    $('#salary-expectations').val('');
                    $('#portfolio').val('');
                    fileChosen.textContent = '  ';
                    $('#privacy').prop('checked', false)

                },
                error: function( error ){
                    $('#error-block').text( error.responseJSON.message );
                }
            });
        }else{
            $('#error-block').html('You must accept the Privacy Policy to continue.').show();
        }
    });

    //->Fix para file personalizado
    const actualBtn = document.getElementById('portfolio');

    const fileChosen = document.getElementById('file-chosen');

    if($(actualBtn).length){
        actualBtn.addEventListener('change', function(){
            fileChosen.textContent = this.files[0].name
        });
    }

    $('#trigger-open-menu').click(function(){
        $('#menu-aside').addClass('show');
    });

    $('#trigger-close-menu').click(function(){
        $('#menu-aside').removeClass('show');
    });

    $('#gallery-home').slick({
        arrows: true,
        prevArrow: "<div class='arrow arrow-left'>",
        nextArrow: "<div class='arrow arrow-right'>",
        infinite: true,
        pauseOnHover: true,
        speed: 1000,
        autoplaySpeed: 6000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        draggable: true,
        swipeToSlide: true,
        touchThreshold: 3,
        touchMove: true,
        responsive: [
			{
			  breakpoint: 991,
			  settings: {
                arrows: false
			  }
		}]
    })

    //Jobs
    $('.read-details').click(function(){
        $(this).parent().slideUp('slow').addClass('hide');
        $(this).parent().siblings('.content').slideToggle('slow').addClass('show');
    })
    $('.hide-details').click(function(){
        $(this).parent().slideUp('slow').addClass('hide');
        $(this).parent().siblings('.extract').slideToggle('slow').addClass('show');
    })
})

window.addEventListener('resize', () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  });
